import { useEffect } from "react";
import { calculateOffset } from "../../../store/map";

const FakeMarker = ({ googleMap, lat, lng}) => {
  const { newLat, newLng } = calculateOffset(lat, lng);

  const createPseudoFakeMarker = () => {
    const pseudoMarker = new window.google.maps.Marker({
      draggable: false,
      animation: window.google.maps.Animation.DROP,
      id: "pseudo_fake_user",
      icon: {
        url: "../assets/extended/location.png",
        scaledSize: new window.google.maps.Size(225,223),
      },
      position: { lat: newLat - 0.9, lng: newLng },
      map: googleMap,
    });
    return pseudoMarker;
  };

  useEffect(() => {
    const pseudoMarker = createPseudoFakeMarker();
    setTimeout(() => {
      pseudoMarker.setMap(googleMap);
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default FakeMarker;